import { AnyIfEmpty } from 'react-redux';
import {
    GET_APPOINTMENT_UNITS_FAILURE,
    GET_APPOINTMENT_UNITS_REQUEST,
    GET_APPOINTMENT_UNITS_SUCCESS,
} from '../constants/appointmentUnits.constants';

const initialState = {
    loading: false,
    data: [],
    count: 0,
    error: '',
};

const appointmentUnitsReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {
        case GET_APPOINTMENT_UNITS_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
                // Clear data on new request to prevent showing stale data during search/filter changes
                data: [],
                count: 0,
            };

        case GET_APPOINTMENT_UNITS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload?.data || [],
                count: action.payload?.count || 0,
                error: '',
            };

        case GET_APPOINTMENT_UNITS_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                count: 0,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default appointmentUnitsReducer;

